module.exports = __webpack_public_path__ + "static/media/reports.0e0575af.png";